<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'
import TipModal from '@/components/tipModal/index.vue'

export default {
  components: {
    TipModal
  },
  data () {
    return {
      noPermissionModal: false
    }
  },
  computed: {
    // userType() {
    //   return this.$store.getters.loginType
    // },
    locale () {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && (setDocumentTitle(`${i18nRender(title)} - ${domTitle}`))

      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    }
  }
}
</script>
<style lang="less">
.noData {
  font-weight: bold;
}
</style>
